<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title align-items-center">
            {{ $t('ChargePro.s') + ' ' + year }}
            <b-button class="btn-medium ml-2" style="padding:5px !important;" variant="primary" @click="decrementYear">
              <chevron-left-icon size="14"/>
            </b-button>
            <b-button style="padding:5px !important;" variant="outline-primary" @click="setYear">
              <span> {{ new Date().getFullYear() }}</span>
            </b-button>
            <b-button class="btn-medium" style="padding:5px !important;" variant="primary" @click="incrementYear">
              <chevron-right-icon size="14"/>
            </b-button>
          </h1>
          <template v-if="totalCount === 0 || totalCount === 1">
            <h2 class="page-subtitle">{{ totalCount }} {{ $t('chargePro') }}</h2>
          </template>
          <template v-else>
            <h2 class="page-subtitle">{{ totalCount }} {{ $t('chargePro.s') }}</h2>
          </template>
        </div>
        <b-button class="btn-medium" variant="primary" @click="clickOnCreateBtn">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a.e') }} {{ $t('chargePro') }}
        </b-button>
      </div>

      <b-card class="border-left-main-color mt-4 mb-3" no-body>
        <div class="mx-4 my-1">
          <div class="mt-2">
            {{ $t('chargePro.total') }}
          </div>
          <div class="main-color-text bold-text level-one-title">
            {{ convertToEuros(totalValue) }} TTC
          </div>
        </div>
      </b-card>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
            ref="B122TableChargePro"
            :delete-item=isEstateAgent
            :edit-item=isEstateAgent
            :empty-button="$t('chargePro.emptyButton').toString()"
            :empty-text="$t('chargePro.emptyText').toString()"
            :empty-title="$t('chargePro.emptyTitle').toString()"
            :fields="tableFields"
            :get-b122-table-results-url="'/chargePro/getB122TableResults?restrictbylong-year=' + startOfYear"
            :initial-sort-by="'date'"
            identifier="B122TableChargePro"
            init-b122-table-url="/chargePro/initB122Table"
            @add="clickOnCreateBtn"
            @clickOnDeleteBtn="clickOnDeleteBtn"
            @clickOnEditBtn="clickOnEditBtn"
            @tableRefreshed="getTotal">
        </b122-table>
      </b-card>
    </b-container>

    <ProfessionalChargesEditModal
        :selectedItem="selectedCharge">
    </ProfessionalChargesEditModal>

    <Item-delete-modal
        :beginsWithVoyel="false"
        :isFeminine="true"
        :selectedItem="selectedCharge"
        controllerName="chargePro"
        itemSingularName="charge"
        itemSingularNameUpp="Charge"
        @didDeleteItem="didDeleteCharge()">
    </Item-delete-modal>

    <ProfessionalChargesDeleteModal
        :selectedItem="selectedCharge"
        @didDeleteItem="didDeleteCharge()">
    </ProfessionalChargesDeleteModal>
  </div>

</template>

<script>

import B122Table from "../../components/b122/B122Table";
import ProfessionalChargesDeleteModal from "./components/ProfessionalChargesDeleteModal";
import ItemDeleteModal from "../../components/b122/ItemDeleteModal"
import ProfessionalChargesEditModal from "./components/ProfessionalChargesEditModal";
import api from "../../services/api";

export default {
  name: "ProfessionalChargesIndex",

  components: {
    B122Table,
    ItemDeleteModal,
    ProfessionalChargesEditModal,
    ProfessionalChargesDeleteModal
  },

  data() {
    return {
      totalCount: 0,
      totalValue: 0,
      username: this.$store.getters.username,
      isEstateAgent: this.$store.getters.isEstateAgent,
      selectedCharge: null,
      year: null,
      startOfYear: null,
    }
  },

  watch: {
    'year': function () {
      this.startOfYear = new Date(this.year, 0, 1).getTime()
      this.getTotal()
    }
  },

  computed: {
    tableFields() {
      let tableFields = [
        {
          label: this.$t('chargePro.Name'),
          key: 'name',
          sortable: true
        },
        {
          label: this.$t('chargePro.Type'),
          key: 'type',
          sortable: true
        },
        {
          label: this.$t('chargePro.Date'),
          key: 'date',
          sortable: true,
          formatter: function (value) {
            return new Date(value).toLocaleDateString()
          }
        },
        {
          label: this.$t('chargePro.Value.HT'),
          key: 'prixHT',
          sortable: true,
          formatter: function (value) {
            return Intl.NumberFormat().format((value / 100).toFixed(2)) + " €"
          }
        },
        {
          label: this.$t('chargePro.Value.TVA'),
          key: 'tvaString',
          sortable: true,
        },
        {
          label: this.$t('chargePro.Value.TTC'),
          key: 'prixTTC',
          sortable: true,
          formatter: function (value) {
            return Intl.NumberFormat().format((value / 100).toFixed(2)) + " €"
          }
        },
        {
          label: '',
          key: 'actions'
        }]
      return tableFields
    }

  },

  created() {
    this.setYear()
  },

  methods: {
    getTotal() {
      let data = new FormData()
      data.append('filters ', JSON.stringify(this.$refs.B122TableChargePro.filters))
      data.append('search ', this.$refs.B122TableChargePro.search)
      data.append('startOfYear', this.startOfYear)

      api({
        method: 'POST',
        url: `/chargePro/getTotalOfChargesByFilters`,
        data: data
      })
          .then((response) => {
            this.totalValue = response.data.total
            this.totalCount = response.data.totalCount
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'ProfessionalChargesIndex'
              })
            }
          })
    },

    convertToEuros(value) {
      let euros = (value / 100).toFixed(2);
      return Intl.NumberFormat().format(euros) + " €"
    },

    decrementYear() {
      this.year--
    },

    setYear() {
      this.year = new Date().getFullYear()
    },

    incrementYear() {
      this.year++
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'ProfessionalChargesCreateEdit',
        params: {
          chargeId: null,
          isChargeSimple: false,
          isChargeGroup: false,
          chargeGroupeId: null
        }
      })
    },

    clickOnEditBtn(row) {
      if (row.item.isChargeGroup) {
        this.selectedCharge = row.item
        this.$bvModal.show('charge-edit-modal')
      } else {
        this.$router.push({
          name: 'ProfessionalChargesCreateEdit',
          params: {
            isChargeSimple: !row.item.isChargeGroup,
            isChargeGroup: false,
            chargeId: row.item.id,
            chargeGroupId: null
          }
        })
      }
    },

    clickOnDeleteBtn(row) {
      if (row.item.isChargeGroup) {
        this.selectedCharge = row.item
        this.$bvModal.show('charge-delete-modal')
      } else {
        this.selectedCharge = row.item
        this.$bvModal.show('item-delete-modal')
      }
    },

    didDeleteCharge() {
      this.selectedCharge = null
      this.$refs.B122TableChargePro.refreshTable()
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/professionalCharges/ProfessionalChargesIndex.vue